module.exports = __webpack_public_path__ + "static/img/border.014a54c4.png";